import { render } from "./HomeWorkflowSection.vue?vue&type=template&id=64bee14c&scoped=true"
import script from "./HomeWorkflowSection.vue?vue&type=script&lang=js"
export * from "./HomeWorkflowSection.vue?vue&type=script&lang=js"

import "./HomeWorkflowSection.vue?vue&type=style&index=0&id=64bee14c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bee14c"]])

export default __exports__